import { ReactNode, useState, useContext, useEffect, useRef } from 'react';
import { DataContext } from 'providers/data';
import GlobalStyles from "@mui/material/GlobalStyles";
import { useLocation, useNavigate, Link } from 'react-router-dom';

import { DecodeToken } from 'utils/decodeToken';

import CssBaseline from '@mui/material/CssBaseline';

import Avatar from '@mui/material/Avatar';
import Modals from 'components/views/Modals';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';
import { Box, List, AppBar, Drawer, Divider, Toolbar, ListItem, IconButton, ListItemText, ListItemIcon, Typography } from '@mui/material';

import { ReactComponent as IcImage } from 'assets/icons/ic-image.svg';
import { ReactComponent as IcCar } from 'assets/icons/menu/ic-car.svg';
import { ReactComponent as IcMenu } from 'assets/icons/menu/ic-menu.svg';
import { ReactComponent as IcCamera } from 'assets/icons/ic-camera.svg';
import { ReactComponent as IcIturan } from 'assets/icons/ic-ituran.svg';
import { ReactComponent as IcClosed } from 'assets/icons/ic-closed.svg';
import { ReactComponent as IcHome } from 'assets/icons/menu/ic-home.svg';
import { ReactComponent as IcChat } from 'assets/icons/menu/ic-chat.svg';
import { ReactComponent as IcPerfil } from 'assets/icons/menu/ic-perfil.svg';
import { ReactComponent as IcDiscount } from 'assets/icons/menu/ic-discount.svg';
import { ReactComponent as IcInvoices } from 'assets/icons/menu/ic-invoices.svg';
import { ReactComponent as IcScheduling } from 'assets/icons/menu/ic-scheduling.svg';
import { ReactComponent as IcSolicitation } from 'assets/icons/menu/ic-solicitation.svg';
import { ReactComponent as IcExchangeCenter } from 'assets/icons/menu/ic-exchange-center.svg';
import { ReactComponent as IcAdditionalServices } from 'assets/icons/menu/ic-additional-services.svg';

import { Container, ContainerNav, ListItemButtonCustom, Footer, ContainerBody } from './styles';

import IturinLogoPerfil from '../../../assets/images/iturin-logo-perfil.png';

const dataMenu = [
    {
        value: 'Início',
        icon: <IcHome />,
        link: '/home',
        external: false
    },
    {
        value: 'Meus dados',
        icon: <IcPerfil />,
        link: '/meus-dados',
        external: false
    },
    {
        value: 'Meus veículos',
        icon: <IcCar />,
        link: '/meus-veiculos',
        external: false
    },
    {
        value: 'Faturas',
        icon: <IcInvoices />,
        link: '/faturas',
        external: false
    },
    {
        value: 'Agendamentos',
        icon: <IcScheduling />,
        link: '/agendamentos',
        external: false
    },
    {
        value: 'Central de trocas',
        icon: <IcExchangeCenter />,
        link: '/central-de-trocas',
        external: false
    },
    {
        value: 'Serviços Adicionais',
        icon: <IcAdditionalServices />,
        link: '/servicos-adicionais',
        external: false
    },
    {
        value: 'Solicitações',
        icon: <IcSolicitation />,
        link: '/solicitacoes',
        external: false
    },
    {
        value: 'Atendimento',
        icon: <IcChat />,
        link: '/atendimento',
        external: false
    },
    {
        value: 'Descontos',
        icon: <IcDiscount />,
        link: '',
        external: true
    },
    // {
    //     value: 'Ituran Frotas',
    //     icon: <IcFleets />,
    //     link: 'https://iweb.ituran.com.br/iweb2/',
    //     external: true
    // },
]

type Params = {
    titlePage?: string;
    children: ReactNode;
    windowProps?: () => Window;
}

const drawerWidth = 230;

const Menu = ({ titlePage, windowProps, children }: Params) => {
    let dateNow = new Date();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [isOpenPhoto, setIsOpenPhoto] = useState(false);
    const [firstTuition, setFirstTuition] = useState(false);
    const [isLoadingPhoto, setIsLoadingPhoto] = useState(false);
    const [showModalClube, setShowModalClube] = useState(false);
    const [tokenDetailsName, setTokenDetailsName] = useState('');
    const [showModalExpired, setShowModalExpired] = useState(false);
    const [photoCustomerData, setPhotoCustomerData] = useState<any>();
    const [photoCustomerState, setPhotoCustomerState] = useState<any>();
    const [showModalPendingUninstall, setShowModalPendingUninstall] = useState(false);
    const [showModalMultipleScheduling, setShowModalMultipleScheduling] = useState(false);
    const [showModalSchedulingMaintenance, setShowModalSchedulingMaintenance] = useState(false);
    const uploadInputRef = useRef<HTMLInputElement | null>(null);

    const { blockClick, isViewModal, selectedCar, invoicesCustomer, photoCustomer, dataGetPlatformRemoval, dataFinancialPending, customerCars, dataFitClientScheduling, handleGetInitialServices, handlePostSavePhoto, handleClearLogout, handleIsViewModal, handleGetUrlAdvantagesClub, handlePostFinancialPending } = useContext(DataContext);

    const handleOpenModal = () => {
        setIsOpenPhoto(true);
        setPhotoCustomerState(photoCustomer);
    }

    const handlePostSavePhotoCustomer = () => {
        setIsLoadingPhoto(true);
        handlePostSavePhoto({
            token: localStorage.getItem('token')!,
            body: {
                foto: photoCustomerData
            }
        });
    }

    const handleValidateLevel = () => {
        if (customerCars?.find(({ CD_PESSOA, CD_PESSOA_BENEFICIARIO }) => CD_PESSOA === CD_PESSOA_BENEFICIARIO)) {
            return true;
        } else {
            return false;
        }
    }

    const onChangePicture = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const reader = new FileReader();
            reader.addEventListener("load", () => {
                setPhotoCustomerState(reader.result);
            });
            setPhotoCustomerData(e.target.files[0]);
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    useEffect(() => {
        if (localStorage.getItem('token') && localStorage.getItem('expires') && localStorage.getItem('time_expires')) {
            const timeExpires = parseFloat(localStorage.getItem('time_expires') || '0');
            const expires = parseFloat(localStorage.getItem('expires') || '0') * 1000;
            const differenceTime = dateNow.getTime() - timeExpires;
            const tokenDetailsAux = DecodeToken();
            tokenDetailsAux && setTokenDetailsName(tokenDetailsAux?.name);

            if (expires > differenceTime) {
                if (!selectedCar) {
                    handleGetInitialServices({ token: localStorage.getItem('token')! });
                }
            } else {
                setShowModalExpired(true);
            }
        } else {
            setShowModalExpired(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (dataFinancialPending === undefined) {
            const tokenDetailsAux = DecodeToken();

            handlePostFinancialPending({
                token: localStorage.getItem('token')!,
                body: {
                    CPF_CNPJ: selectedCar ? selectedCar?.NR_CNPJ_CPF : tokenDetailsAux.document,
                    ID_MOTIVO: 0,
                    DS_PLACA: selectedCar?.PLACA || '',
                    CD_PARCEIRO: 1783625,
                    FL_PAGAS: true
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, dataFinancialPending]);

    useEffect(() => {
        if (!isViewModal) {
            if (dataFitClientScheduling && dataFitClientScheduling.length > 0 && dataGetPlatformRemoval && dataGetPlatformRemoval?.length > 0) {
                setShowModalMultipleScheduling(true);
                return;
            }

            if (dataGetPlatformRemoval && dataGetPlatformRemoval?.length > 0) {
                if (Array.isArray(dataFinancialPending)) {
                    if (dataFinancialPending.length > 0) {
                        if (dataFinancialPending.find(({ NM_TIPO_COBRANCA }) => NM_TIPO_COBRANCA.includes('Desativação'))) {
                            setFirstTuition(true);
                        } else {
                            setFirstTuition(false);
                        }
                    }
                }
                setShowModalPendingUninstall(true);

            }

            if (dataFitClientScheduling && dataFitClientScheduling?.length > 0) {
                setShowModalSchedulingMaintenance(true);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGetPlatformRemoval, invoicesCustomer, dataFitClientScheduling, dataFinancialPending]);

    useEffect(() => {
        if (photoCustomer) {
            setIsLoadingPhoto(false);
            setIsOpenPhoto(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [photoCustomer]);

    const windowState = windowProps;
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <ContainerNav>
            <GlobalStyles
                styles={{
                    'iframe[title="Mensagem da empresa"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title = "Fechar mensagem"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title="Close message"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title="Company message"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title="Message from company"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    '#launcher': {
                        display: 'none'
                    }
                }}
            />
            <Box>
                <Box sx={{
                    alignItems: 'center',
                    paddingBottom: '1rem',
                    justifyContent: 'end',
                    display: {
                        xs: 'flex',
                        md: 'none'
                    }
                }}>
                    <IcClosed onClick={() => setMobileOpen(false)} />
                </Box>

                <Box sx={{
                    alignItems: 'center',
                    paddingBottom: {
                        md: '1rem',
                        lg: '2rem'
                    },
                    justifyContent: 'center',
                    display: {
                        xs: 'none',
                        md: 'flex'
                    }
                }}>
                    <IcIturan style={{ maxHeight: '2.81rem' }} />
                </Box>

                <Box sx={{
                    width: '100%',
                    gap: '.4rem',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    paddingBottom: {
                        md: '.4rem',
                        lg: '.75rem'
                    },
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        width: '4.4rem',
                        display: 'flex',
                        position: 'relative',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <Avatar
                            alt="perfil current"
                            src={photoCustomer || IturinLogoPerfil}
                            sx={{
                                width: {
                                    xs: '4rem',
                                    md: '3.1875rem'
                                },
                                height: {
                                    xs: '4rem',
                                    md: '3.1875rem'
                                },
                                border: '1.98141px solid #FFFFFF;'
                            }}
                        />
                        {/* <BoxPerfilImg logoperfil={IturinLogoPerfil} /> */}

                        <Box sx={{
                            display: 'flex',
                            width: '1.5rem',
                            height: '1.5rem',
                            right: '0',
                            bottom: '0',
                            padding: '.25rem',
                            position: 'absolute',
                            alignItems: 'center',
                            borderRadius: '100px',
                            justifyContent: 'center',
                            backgroundColor: 'white',
                            border: '1px solid #0C1C33',
                            cursor: !blockClick ? 'pointer' : 'not-allowed'
                        }}
                            onClick={() => !blockClick && handleOpenModal()}
                        >
                            <IcCamera style={{ width: '100%', height: '100%' }} />
                        </Box>
                    </Box>
                    <Typography sx={{
                        fontSize: {
                            xs: '1.11rem',
                            md: '.875rem'
                        }
                    }}
                        textAlign='center'
                        fontWeight={600}
                        color='white'
                        textTransform='capitalize'
                    >
                        {`${selectedCar ? selectedCar.NOME_CLIENTE_ABREVIADO : tokenDetailsName}`.toLowerCase()}
                    </Typography>
                </Box>

                <Divider sx={{ backgroundColor: 'grey.400' }} />
                <List sx={{ gap: { md: '.1rem', lg: '.375rem' }, display: 'flex', flexDirection: 'column', padding: { md: '.5rem 0 0', lg: '.875rem 0 0' } }}>
                    {dataMenu.map(({ value, icon, link, external }, index) => (
                        <ListItem key={index} disablePadding>
                            <ListItemButtonCustom
                                to={blockClick ? (([0, 1, 3, 4, 7].indexOf(index) >= 0) ? link : '') : handleValidateLevel() ? (external ? '' : link) : selectedCar?.CD_PESSOA === 1079756 ? (([0, 1, 2, 3, 7, 8].indexOf(index) >= 0) ? link : '') : (([0, 1, 2, 3, 7].indexOf(index) >= 0) ? link : '')}
                                aria-disabled={blockClick ? ([0, 1, 3, 4, 7, 8].indexOf(index) < 0) : !handleValidateLevel() && (selectedCar?.CD_PESSOA === 1079756 ? ([4, 5, 6].indexOf(index) >= 0) : ([4, 5, 6, 8].indexOf(index) >= 0))}
                                activeselected={pathname.split('/')[1] === link.replace('/', '') ? 'active' : 'disabled'}
                                onClick={() =>
                                    external && !blockClick ?
                                        (index === 9 && handleValidateLevel()) ?
                                            setShowModalClube(true)
                                            :
                                            (selectedCar?.CD_PESSOA === 1079756) ? setShowModalClube(true) : null
                                        :
                                        null
                                }
                            >
                                <ListItemIcon style={{ minWidth: '1.5625rem', display: 'flex', justifyContent: 'center' }}>
                                    {icon}
                                </ListItemIcon>
                                <ListItemText sx={{
                                    margin: '0 auto',
                                    display: 'flex',
                                    paddingTop: '3.5px'
                                }}>
                                    <Typography variant='subtitle2' color='grey.400' fontWeight={400}>
                                        {value}
                                    </Typography>
                                </ListItemText>
                            </ListItemButtonCustom>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <List sx={{ padding: '0' }}>
                <ListItem disablePadding>
                    <ListItemButtonCustom
                        to='/'
                        activeselected='disabled'
                        onClick={() => { localStorage.clear(); handleClearLogout(); }}
                    >
                        <ListItemText sx={{
                            margin: '0 auto',
                            display: 'flex',
                            paddingTop: '3.5px',
                            justifyContent: 'center'
                        }}>
                            <Typography variant='subtitle2' color='grey.400' fontWeight={400}>
                                <u>Sair</u>
                            </Typography>
                        </ListItemText>
                    </ListItemButtonCustom>
                </ListItem>
            </List>
        </ContainerNav >
    );

    const container = windowState !== undefined ? () => windowState().document.body : undefined;

    return (
        <Container>
            <Box sx={{
                display: { xs: 'grid', md: 'flex' },
                width: '100%',
                overflow: 'hidden',
                gridTemplateRows: '5.25rem auto 4.375rem'
            }}>
                <CssBaseline />
                <AppBar
                    position="fixed"
                    sx={{
                        width: { sm: `calc(100% - ${drawerWidth}px)` },
                        ml: { sm: `${drawerWidth}px` },
                        display: {
                            md: 'none',
                            xs: 'flex'
                        },
                        height: '5.25rem',
                        justifyContent: 'center',
                    }}
                >
                    <Toolbar sx={{ minHeight: '5.25rem' }}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 2, display: { sm: 'none' }, margin: '0', padding: '0' }}
                        >
                            <IcMenu />
                        </IconButton>
                        <Box sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            paddingRight: '1.5rem'
                        }}>
                            <a href='/home'><IcIturan style={{ maxHeight: '3.4375rem' }} /></a>
                        </Box>
                    </Toolbar>
                </AppBar>
                <Box
                    component="nav"
                    sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                    aria-label="mailbox folders"
                >
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                        }}
                    >
                        {drawer}
                    </Drawer>
                    <Drawer
                        variant="permanent"
                        sx={{
                            display: { xs: 'none', sm: 'block' },
                            '& .MuiDrawer-paper': {
                                boxSizing: 'border-box',
                                width: drawerWidth,
                                backgroundColor: 'primary.main',
                                borderRight: '4px solid #97C93D'
                            },
                        }}
                        open
                    >
                        {drawer}
                    </Drawer>
                </Box>
                <Box
                    id="box-main"
                    component="main"
                    sx={{
                        flexGrow: 1,
                        overflow: 'auto',
                        width: { sm: `calc(100% - ${drawerWidth}px)` },
                        padding: {
                            xs: '1.25rem 1rem 5.875rem',
                            md: '2rem 4% 2rem 4%',
                            lg: '2rem 3.56rem 2rem 3.875rem'
                        }
                    }}
                >
                    {titlePage &&
                        <Typography
                            sx={{
                                width: '100%',
                                fontWeight: 700,
                                lineHeight: '30px',
                                fontSize: '1.5625rem',
                                marginBottom: '1.64rem',
                                textTransform: 'uppercase',
                                color: 'rgba(141, 155, 181, 0.5)',
                                borderBottom: '1px solid rgba(141, 155, 181, 0.5)',
                                display: {
                                    xs: 'none',
                                    md: 'block'
                                }
                            }}>
                            {titlePage}
                        </Typography>
                    }
                    <ContainerBody>
                        {children}
                    </ContainerBody>
                </Box>

                {!pathname.includes('servicos-adicionais') &&
                    <Footer>
                        <List sx={{ gap: '.375rem', height: '100%', display: 'flex', padding: '0 1rem .625rem', justifyContent: 'space-between' }}>
                            {dataMenu.map(({ value, icon, link }, index) => (
                                index < 4 &&
                                <ListItem disablePadding key={index} sx={{
                                    width: 'fit-content',
                                    height: '100%',
                                    zIndex: '999'
                                }}>
                                    <ListItemButtonCustom className='content-mobile' to={link} activeselected={pathname.split('/')[1] === link.replace('/', '') ? 'active' : 'disabled'}>
                                        <ListItemIcon style={{ minWidth: '1.5625rem', display: 'flex', justifyContent: 'center' }}>
                                            {icon}
                                        </ListItemIcon>
                                        <ListItemText sx={{
                                            margin: '0 auto',
                                            display: 'flex',
                                        }}>
                                            <Typography variant='subtitle2' color='grey.400' fontWeight={400}>
                                                {value}
                                            </Typography>
                                        </ListItemText>
                                    </ListItemButtonCustom>
                                </ListItem>
                            ))}
                        </List>
                    </Footer>
                }

                <Modals open={showModalPendingUninstall}>
                    <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '23.4rem' } }}>
                        <Box sx={{
                            display: 'grid',
                            maxWidth: '20rem',
                            padding: { xs: '1.7rem 0 1rem', md: '1.7rem 0 1rem' },
                            borderRadius: '8px 8px 0 0',
                            rowGap: '.6rem',
                            margin: '0 auto'
                        }}>
                            <Typography fontSize='1.5625rem' fontWeight={700} lineHeight='25px' marginBottom='.7rem'>
                                APROVEITE A <br />
                                OPORTUNIDADE!
                            </Typography>

                            <Typography fontSize='.875rem' lineHeight={1.2}>
                                <b>Atenção, </b> você tem um serviço desativado, mas
                                não se preocupe, queremos te ajudar com isso.
                            </Typography>
                            <Typography fontSize='1rem' lineHeight={1.2} color='primary.light' >
                                {(dataGetPlatformRemoval && dataGetPlatformRemoval.length > 0) &&
                                    <span style={{ color: '#0AA8E3', fontSize: '1rem' }}>
                                        VEÍCULO: <b>{dataGetPlatformRemoval[0]?.DS_PLACA || dataGetPlatformRemoval[0]?.DS_CHASSI || ''}</b>
                                    </span>
                                }
                            </Typography>
                            <Typography fontSize='.875rem' lineHeight={1.2}>
                                Você tem a <b>oportunidade</b> de reativar o seu
                                serviço com <b style={{ color: '#97C93D' }}>ofertas exclusivas!*</b>.
                            </Typography>

                            {firstTuition ?
                                <Typography fontSize='.875rem' lineHeight={1.2}>
                                    Clique em <b>”AGENDAR RETIRADA”</b> para
                                    prosseguir, ou se preferir, visualize o boleto para
                                    pagamento&nbsp;
                                    <Link
                                        to="/faturas"
                                        style={{ color: '#0C1C33', textDecoration: 'underline' }}
                                        onClick={() => { handleIsViewModal(); setShowModalPendingUninstall(false); }}
                                    >
                                        <b>clicando aqui.</b>
                                    </Link>
                                </Typography>
                                :
                                <>
                                    <Typography fontSize='.875rem' lineHeight={1.2}>
                                        *Para reativação é necessário que todos os
                                        boletos em aberto estejam quitados.
                                    </Typography>
                                    <Typography fontSize='.875rem' lineHeight={1.2}>
                                        Caso tenha interesse na retirada, clique em
                                        <b> AGENDAR RETIRADA</b> e prossiga!
                                    </Typography>
                                </>
                            }
                        </Box>
                        <Box sx={{
                            display: 'grid',
                            rowGap: '.9375rem',
                            justifyContent: 'center',
                            borderRadius: '0 0 8px 8px',
                            backgroundColor: 'primary.main',
                            padding: '1rem 0 1.6rem',
                            'button': {
                                width: '15.68rem'
                            }
                        }}>
                            <Box>
                                <Typography fontSize='.75rem' color='white' paddingBottom='.2rem' textAlign='center'>
                                    Opção: <b>Reativação</b>
                                </Typography>
                                <ButtonRectangle
                                    name='QUERO REATIVAR'
                                    onClick={() => window.open('https://api.whatsapp.com/send/?phone=551136169000', '_target')} />
                            </Box>
                            <ButtonRectangle
                                name='AGENDAR RETIRADA'
                                onClick={() => { handleIsViewModal(); setShowModalPendingUninstall(false); navigate('/agendamentos'); }}
                            />
                            <Box sx={{ 'button': { color: 'white', borderColor: 'white', ':hover': { borderColor: 'white' } } }}>
                                <ButtonOutlined
                                    name='CANCELAR'
                                    onClick={() => { handleIsViewModal(); setShowModalPendingUninstall(false); }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Modals>

                <Modals open={showModalSchedulingMaintenance} handleClick={(e) => setShowModalSchedulingMaintenance(e)}>
                    <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '23.5rem' } }}>
                        <Box sx={{ padding: { xs: '1.5rem .5rem .68rem', md: '1.64rem 1rem 1rem' }, borderRadius: '8px 8px 0 0' }}>
                            <Typography fontSize='1.56rem' fontWeight={700} lineHeight='25px'>
                                AGENDAMENTO <br />
                                DE REVISÃO
                            </Typography>

                            <Typography fontSize='.875rem' lineHeight='20px' margin='1rem 1rem .6rem'>
                                Verificamos que você tem uma atualização de versão do seu rastreador.
                            </Typography>
                            <Typography fontSize='.875rem' lineHeight='20px'>
                                Para seguir o seu agendamento clique no botão abaixo.
                            </Typography>
                        </Box>
                        <Box sx={{
                            borderRadius: '0 0 8px 8px',
                            backgroundColor: 'primary.main',
                            padding: '1.6rem 3.81rem .8rem',
                            'button': {
                                width: '100%',
                                height: '2.5rem',
                                maxWidth: '15.68rem',
                                marginBottom: '.9375rem'
                            }
                        }}>
                            <ButtonRectangle
                                name='AGENDAR'
                                onClick={() => { handleIsViewModal(); setShowModalSchedulingMaintenance(false); navigate('/agendamentos'); }}
                            />
                            <Box sx={{ 'button': { color: 'white', borderColor: 'white', ':hover': { borderColor: 'white' } } }}>
                                <ButtonOutlined
                                    name='CANCELAR'
                                    onClick={() => { handleIsViewModal(); setShowModalSchedulingMaintenance(false); }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Modals>

                <Modals open={showModalMultipleScheduling} handleClick={(e) => setShowModalMultipleScheduling(e)}>
                    <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '23.5rem' } }}>
                        <Box sx={{ padding: { xs: '1.5rem .5rem .68rem', md: '1.64rem 1rem 1rem' }, borderRadius: '8px 8px 0 0' }}>
                            <Typography fontSize='1.56rem' fontWeight={700} lineHeight='25px'>
                                AGENDAMENTOS <br />
                                PENDENTES
                            </Typography>

                            <Typography fontSize='.875rem' lineHeight='20px' margin='1rem 1rem .6rem'>
                                Parece que existem alguns agendamentos para serem feitos.
                            </Typography>
                            <Typography fontSize='.875rem' lineHeight='20px'>
                                Clique no botão abaixo e agende agora mesmo.
                            </Typography>
                        </Box>
                        <Box sx={{
                            borderRadius: '0 0 8px 8px',
                            backgroundColor: 'primary.main',
                            padding: '1.6rem 3.81rem .8rem',
                            'button': {
                                width: '100%',
                                height: '2.5rem',
                                maxWidth: '15.68rem',
                                marginBottom: '.9375rem'
                            }
                        }}>
                            <ButtonRectangle
                                name='AGENDAR'
                                onClick={() => { handleIsViewModal(); setShowModalMultipleScheduling(false); navigate('/agendamentos'); }}
                            />
                            <Box sx={{ 'button': { color: 'white', borderColor: 'white', ':hover': { borderColor: 'white' } } }}>
                                <ButtonOutlined
                                    name='CANCELAR'
                                    onClick={() => { handleIsViewModal(); setShowModalMultipleScheduling(false); }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Modals>

                <Modals open={isOpenPhoto} handleClick={(e) => setIsOpenPhoto(e)}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        padding: '1.5rem 1.5625rem 2.5625rem'
                    }}>
                        <Typography sx={{
                            color: 'white',
                            fontWeight: 700,
                            fontSize: '1.25rem',
                            borderRadius: '40px',
                            padding: '.58rem 3.31rem .3rem',
                            backgroundColor: 'primary.light',
                        }}>
                            FOTO DO PERFIL
                        </Typography>

                        <Typography variant='body2' fontWeight={400} margin='1.625rem 0 1.25rem'>
                            Deixa a sua área do cliente do seu jeito:
                        </Typography>

                        <Box sx={{ display: 'flex', gap: '2.9375rem', marginBottom: '1.6875rem' }}>
                            <Box>
                                <Avatar
                                    alt="perfil current"
                                    src={photoCustomerState || IturinLogoPerfil}
                                    sx={{
                                        width: '6.25rem',
                                        height: '6.25rem',
                                        border: '2px solid #8D9BB5'
                                    }}
                                />
                                <Typography variant='body2' fontWeight={400} textAlign='center' paddingTop='4px'>
                                    Foto atual
                                </Typography>
                            </Box>

                            <Box sx={{
                                width: '7.5rem',
                                display: 'flex',
                                height: '6.875rem',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '2px solid rgba(151, 201, 61, 0.5)',
                                boxShadow: '0px 3px 6px #97C93D',
                                borderRadius: '12px',
                                cursor: 'pointer'
                            }}
                                onClick={() => uploadInputRef.current && uploadInputRef.current.click()}
                            >
                                <input ref={uploadInputRef} type="file" onChange={onChangePicture} hidden />
                                <Box
                                    sx={{
                                        height: '100%',
                                        display: 'flex',
                                        padding: '1rem 0 .6rem',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    <IcImage />
                                    <Typography fontWeight={600} textAlign='center' fontSize='1rem'>
                                        Carregar <br /> foto
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                        <Box sx={{
                            width: '100%',
                            display: 'flex',
                            gap: '.75rem',
                            'button': {
                                width: '50%',
                                height: '2.5rem'
                            }
                        }}>
                            <ButtonOutlined name='CANCELAR' onClick={() => setIsOpenPhoto(false)} />
                            <ButtonRectangle name='SALVAR' loadingBtn={isLoadingPhoto} onClick={() => handlePostSavePhotoCustomer()} />
                        </Box>
                    </Box>
                </Modals>

                <Modals open={showModalClube}>
                    <Box sx={{ textAlign: 'center', width: { xs: 'calc(100vw - 2rem)', md: '23.31rem' } }}>
                        <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                            <Typography fontSize='1.5625rem' fontWeight={700}>
                                Descontos
                            </Typography>
                            <Typography fontSize='1rem' lineHeight='21px' paddingTop='.625rem'>
                                O link será aberto em uma nova aba.
                                <br />
                                Deseja continuar?
                            </Typography>
                        </Box>
                        <Box sx={{
                            borderRadius: '0 0 8px 8px',
                            padding: '1.875rem 3.81rem 1.75rem',
                            backgroundColor: 'primary.main',
                            'button': {
                                width: '100%',
                                height: '2.5rem',
                            }
                        }}>
                            <ButtonRectangle name='CONTINUAR' onClick={() => { handleGetUrlAdvantagesClub(); setShowModalClube(false); }} />
                            <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                                <ButtonOutlined name='CANCELAR' onClick={() => setShowModalClube(false)} />
                            </Box>
                        </Box>
                    </Box>
                </Modals>

                <Modals open={showModalExpired}>
                    <Box sx={{
                        borderRadius: '8px',
                        textAlign: 'center',
                        width: { xs: 'calc(100vw - 2rem)', md: '21rem' },
                    }}>
                        <Box sx={{ padding: '1.5rem 0 1rem', borderRadius: '8px 8px 0 0' }}>
                            <Typography fontSize='1.25rem' lineHeight='1.2'>
                                <b>Sua sessão expirou,</b> faça <br />
                                seu login novamente!
                            </Typography>
                        </Box>

                        <Box sx={{
                            borderRadius: '0 0 8px 8px',
                            backgroundColor: 'primary.main',
                            padding: '1.5rem 0',
                            'button': {
                                width: '100%',
                                height: '2.5rem',
                                maxWidth: '14.5rem',
                            }
                        }}>
                            <ButtonRectangle
                                name='FAZER LOGIN'
                                onClick={() => { navigate('/'); handleClearLogout(); setShowModalExpired(false); }}
                            />
                        </Box>
                    </Box>
                </Modals>
            </Box >
        </Container >
    );
}

export default Menu;